import { FinanceRate, WorkType } from '@kanda-libs/ks-frontend-services';
import { useEnquiryContext } from 'pages/Enquiry/context';
import { useMemo } from 'react';
import { extractAllFinanceRatesFromInfoWorkTypes } from 'utils';

export interface LayoutSidebarHook {
  workTypes: WorkType[] | undefined;
  financeRates: FinanceRate[] | undefined;
  isLoading: boolean;
}

export default function useLayoutSidebar(
  inputIsLoading = false,
): LayoutSidebarHook {
  const {
    workTypes,
    infoWorkTypes,
    isLoading: enquiryIsLoading,
  } = useEnquiryContext();

  const financeRates = useMemo(() => {
    if (!infoWorkTypes) return undefined;
    return extractAllFinanceRatesFromInfoWorkTypes(infoWorkTypes);
  }, [infoWorkTypes]);

  const isLoading = useMemo(
    () => inputIsLoading || enquiryIsLoading,
    [inputIsLoading, enquiryIsLoading],
  );

  return {
    workTypes,
    financeRates,
    isLoading,
  };
}
